export const isEmpty = (params) => {
  if (typeof params === "string" && params === "") {
    return true;
  }
};
